
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.992 9.078v1.688h-.89V9.078H2.477v-.86h1.625V6.54h.89v1.68h1.633v.86H4.992zm-3.476-.015c0 1.109.195 1.895.586 2.359.39.463 1.21.695 2.46.695s2.07-.229 2.461-.687c.396-.464.594-1.253.594-2.367V.89h1.11v8.312c0 1.287-.318 2.263-.954 2.93-.63.667-1.7 1-3.21 1-1.584 0-2.672-.328-3.266-.985-.594-.656-.89-1.58-.89-2.773V.891h1.109v8.171z","fill":"currentColor"}})])
          )
        }
      }
    